import { z, ZodType } from 'zod';

export type Highroller = {
	username: string;
	profit: number;
	multiplier: number;
};

export const highrollerSchema: ZodType<Highroller> = z.object({
	username: z.string(),
	profit: z.number(),
	multiplier: z.number(),
});
